import { useState, useEffect } from "react";
import {  loadMaterialCode } from "../services/materialCategory";

const useMaterialCode = (editID) => {
    const [materialCode, setMaterialCode] = useState([]);    


    const generateMaterialCodeByCategory = async (categoryID, categoryDescription) => {
        const para = {
          p_companyid: localStorage.getItem("companyid"),
          p_plantid: 1,
          p_category_code: categoryDescription
        };
    
        try {
          const data = await loadMaterialCode(para);
          if (data && data.length > 0) {
            setMaterialCode(data[0].material_code); // Assumes backend returns `material_code`
          }
        } catch (error) {
          console.error("Failed to generate material code:", error);
        }
      };

 

    return {
        materialCode,
        setMaterialCode,        
        generateMaterialCodeByCategory,
    };
};

export default useMaterialCode;
